import React from 'react'
import { object, arrayOf } from 'prop-types'

import API from 'utils/API'
import getListFromDesc from 'utils/getListFromDesc'
import { branch } from 'baobab-react/higher-order'

import BaseTemplate from 'components/templates/BaseTemplate'

import PageBanner from 'components/organisms/PageBanner'
import PromotionBanner from 'components/organisms/PromotionBanner'
import DetailRelatedCampus from 'components/organisms/DetailRelatedCampus'
import SectionRelatedArticles from 'components/organisms/SectionRelatedArticles'
import StickyBottomMajorCareer from 'components/organisms/StickyBottomMajorCareer'
import DescSection from 'components/molecules/DescSection'
import MajorSkills from './MajorSkills'
import MajorWhy from './MajorWhy'
import MajorProspect from './MajorProspect'
import MajorCollege from './MajorCollege'
import MajorTestimonies from './MajorTestimonies'

const MajorDetail = ({ studyField, testimonies, campusRecommendations }) => {
  const {
    id,
    name,
    parentName,
    iconName,
    liked,
    benefits,
    majorBanner,
    promotion,
    description,
    descriptionTitle,
    skills,
    prospect,
    professions,
    campusLife,
    article_tags: articleTags,
  } = studyField

  const sections = [
    {
      target: '#description',
      text: 'Deskripsi',
      show: Boolean(descriptionTitle || description),
    },
    {
      target: '#skills',
      text: 'Pengetahuan & Keahlian',
      show: skills.list.length > 0,
    },
    {
      target: '#benefits',
      text: 'Keunggulan',
      show: Boolean(benefits.title),
    },
    {
      target: '#careers',
      text: 'Karier',
      show: Boolean(prospect.title || prospect.description),
    },
    {
      target: '#campus-life',
      text: 'Perkuliahan',
      show: Boolean(campusLife.title || campusLife.description),
    },
    {
      target: '#testimonies',
      text: 'Testimoni',
      show: testimonies.length > 0,
    },
    {
      target: '#related-campus',
      text: 'Kampus',
      show: campusRecommendations.length > 0,
    },
    {
      target: '#related-articles',
      text: 'Artikel',
      show: articleTags.length > 0,
    },
  ]
  const benefitsList = benefits && benefits.description && getListFromDesc(benefits.description)
  const tagsQuery = articleTags.join('&tags[]=')
  const articlesSource = `${API.endPoints().articles}?tags[]=${tagsQuery}`


  return (
    <BaseTemplate
      sections={sections}
      stickyBottomContent={
        <StickyBottomMajorCareer
          title={`Jurusan ${name}`}
          iconName={iconName}
          likeStatus={liked}
          likeTarget={id}
          kind="studyFields"
        />
      }
      actionContent={{
        likeStatus: liked,
        likeTarget: id,
        kind: 'studyFields',
      }}
      useBackToTop
      useNewHeader
      useStickyBottom
    >
      <div className="major-detail-page">
        <PageBanner
          title={`Jurusan ${name}`}
          subtitle={parentName}
          iconName={iconName}
          imgSrc={majorBanner.desktop}
          likeStatus={liked}
          likeTarget={id}
          kind="studyFields"
        />
        {
          (descriptionTitle || description) &&
            <DescSection
              title={descriptionTitle && descriptionTitle}
              description={description && description}
            />
        }
        {
          skills.list.length > 0 && <MajorSkills
            skills={skills.list}
            imgSrc={skills.banner.desktop}
            imgAlt={skills.banner.desktopAlt}
          />
        }
        <PromotionBanner promotion={promotion}/>
        {
          benefits.title &&
          <MajorWhy
            title={benefits.title}
            subtitle={benefits.subtitle}
            reasons={benefitsList}
          />
        }
        {
          (prospect.title || prospect.description) &&
          <MajorProspect
            title={prospect.title}
            detail={prospect.description}
            list={professions}
          />
        }
        {
          (campusLife.title || campusLife.description) &&
          <MajorCollege
            title={campusLife.title}
            content={campusLife.description}
            imgSrc={campusLife.bannerDesktop}
            imgAlt={campusLife.bannerDesktopAlt}
          />
        }
        { (testimonies.length > 0) &&
          <MajorTestimonies testimonies={testimonies}/>
        }
        {
          (campusRecommendations.length > 0) &&
          <DetailRelatedCampus schools={campusRecommendations}/>
        }
        {
          (articleTags.length > 0) &&
          <SectionRelatedArticles sourceUrl={articlesSource}/>
        }
        <style jsx>
          {`
            .major-detail-page {
              background-color: #fff;
              color: #0c2846;
            }
          `}
        </style>
      </div>
    </BaseTemplate>
  )
}

MajorDetail.propTypes = {
  studyField: object,
  testimonies: arrayOf(object),
  campusRecommendations: arrayOf(object),
}

export { MajorDetail }

export default branch({
  studyField: ['serverProps', 'studyField'],
  schools: ['serverProps', 'schools'],
  testimonies: ['serverProps', 'testimonies'],
  campusRecommendations: ['serverProps', 'campusRecommendations'],
}, MajorDetail)
